import { BUKU_PROMOSI } from '../types'

export default (def = 'NULL', action) => {
    switch (action.type) {
        case BUKU_PROMOSI:
            return action.payload;
        default:
            return def;
    }
}